export enum CardThemeType {
  Light = 1,
  Dark = 2,
  Transparent = 3,
  Glass = 4,
  Dashed = 5,
  Primary = 6,
  Overlay = 7,
  DarkGlass = 8,
  DarkGlow = 9,
  Grey = 10,
  Black = 11,
  GreyGradient = 12,
  PatternGlass = 13,
  LightShadow = 14,
  LightBorder = 15,
  GlassSecondary = 16,
}
